/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import { gettext } from "modules/django-i18n";
import overlayMixin from "../mixins/overlay-mixin";
import ShippingAndReturnsOverlay from "components/overlays/shipping-and-returns-overlay";

const DetailsOverlay = baustein.register("two-tap-details-overlay", {
    mixins: [overlayMixin],

    defaultOptions: {
        overlaySize: "small",
        linkId: null,
        privacyHref: null,
        termsHref: null
    },

    setupEvents(add) {
        add("click", "a.shipping-terms", this.onClickTerms);
    },

    onClickTerms(event) {
        event.stopPropagation();
        const shippingAndReturnsOverlay = new ShippingAndReturnsOverlay({
            linkId: this.options.linkId
        });

        shippingAndReturnsOverlay.appendTo(document.body);
        shippingAndReturnsOverlay.open();
    },

    onOverlayCloseIntent() {
        this.close();
    },

    /**
     * Get the overlay content
     */
    getOverlayContent() {
        // "Express Checkout Details"
        const expressCheckoutTitle = gettext("product.buy_area.express_checkout_overlay.title");
        // "You are placing an order for this individual product. If you would
        // like to purchase another, different product please complete a
        // separate order. Your order will be fulfilled by the individual
        // retailer and not by Lyst. If you require customer support or
        // tracking of your order please contact the retailer directly."
        const expressCheckoutInfo = gettext(
            "product.buy_area.express_checkout_overlay.express_checkout_info"
        );
        // "View shipping & returns info"
        const shippingText = gettext(
            "product.buy_area.open_view_shipping_and_returns_info_overlay_btn_text"
        );

        const lystTermsProps = `href="${this.options.termsHref}" target="_blank"`;
        const lystPrivacyProps = `href="${this.options.privacyHref}" target="_blank"`;
        // "By clicking Place Order you confirm that you have read and accept
        // the <a {lyst_terms_and_conditions_link_props}>terms & conditions</a>
        // and <a {lyst_privacy_policy_link_props}>privacy policy</a> of Lyst
        // and each retailer you order from."
        const expressCheckoutTerms = gettext(
            "product.buy_area.express_checkout_overlay.terms_and_privacy_links",
            {
                lyst_terms_and_conditions_link_props: lystTermsProps,
                lyst_privacy_policy_link_props: lystPrivacyProps
            }
        );
        return Promise.resolve(`
            <h3>${expressCheckoutTitle}</h3>
            <p>${expressCheckoutInfo}</p>
            <p><a class="shipping-terms">${shippingText}</a></p>
            <p>${expressCheckoutTerms}</p>
        `);
    }
});

baustein.register("express-checkout-details", {
    defaultOptions: {
        dataLinkId: null,
        dataPrivacyHref: null,
        dataTermsHref: null
    },

    setupEvents(add) {
        add("click", this.onClick);
    },

    onClick(event) {
        event.stopPropagation();
        const overlay = new DetailsOverlay({
            linkId: this.options.dataLinkId,
            privacyHref: this.options.dataPrivacyHref,
            termsHref: this.options.dataTermsHref
        });

        overlay.appendTo(document.body);
        overlay.open();
    }
});

baustein.register("express-checkout-shipping", {
    defaultOptions: {
        linkId: null
    },

    setupEvents(add) {
        add("click", this.onShippingInfoClick);
    },

    onShippingInfoClick(event) {
        event.stopPropagation();
        const overlay = new ShippingAndReturnsOverlay({
            linkId: this.options.linkId
        });

        overlay.appendTo(document.body);
        overlay.open();
    }
});

const EstimatedTaxOverlay = baustein.register("estimated-tax-overlay", {
    mixins: [overlayMixin],

    defaultOptions: {
        overlaySize: "small"
    },

    onOverlayCloseIntent() {
        this.close();
    },

    getOverlayContent() {
        // "Estimated Tax Details"
        const title = gettext("express_checkout.shipping.title");
        // "TwoTap will estimate the tax charge and include this in your order total."
        const description1 = gettext("express_checkout.shipping.description1");
        // "You can check the retailer’s full tax policy by visiting their help center.
        // (You can find the name of the retailer on the Lyst product page.)"
        const description2 = gettext("express_checkout.shipping.description2");
        // "When the retailer processes your order it will calculate the actual tax amount
        // and will include this in the final order total."
        const description3 = gettext("express_checkout.shipping.description3");
        // "For security purposes, orders placed on Lyst are processed as payment card
        // purchases by TwoTap."
        const twoTapDescription = gettext("express_checkout.shipping.twotap_description");

        return Promise.resolve(`
            <h3>${title}</h3>
            <p>${description1}</p>
            <p>${description2}</p>
            <p>${description3}</p>
            <h4 class="express-checkout-overlays__twotap-logo">TwoTap</h4>
            <p class="express-checkout-overlays__twotap-description">${twoTapDescription}</p>
        `);
    }
});

baustein.register("express-checkout-tax", {
    setupEvents(add) {
        add("click", this.onClick);
    },

    onClick(event) {
        event.stopPropagation();
        const overlay = new EstimatedTaxOverlay();

        overlay.appendTo(document.body);
        overlay.open();
    }
});

